import { useContext, useEffect, useState } from "react";
import { UserContext } from "../context/UserContext";
import { Link } from "react-router-dom";
import Paystack from "@paystack/inline-js";
import axios from "axios";

function PlanCard({ plan, userSubscription, setUserSubscription }) {
  // const infoElements = plan.planInfo.map((info) => <li key={info}>{info}</li>);
  const { user } = useContext(UserContext);
  const isSubscribed =
    userSubscription && new Date(userSubscription.expiresAt) > new Date();
  const [price, setPrice] = useState(0);

  const handlePayPlan = () => {
    const paystack = new Paystack();

    paystack.newTransaction({
      key: "pk_live_5953a92f2529095204383aaab631f2813fe810a1",
      email: user?.email,
      firstName: user?.username.split(" ")[0] && "undifind",
      lastName: user?.username.split(" ")[0] && "undifind",
      currency: "GHS",
      amount: (price || 100) * 100,
      phone: user?.phoneNumber,
      channels: [
        "card",
        "bank",
        "ussd",
        "qr",
        "eft",
        "mobile_money",
        "bank_transfer",
      ],

      onSuccess: (transaction) => {
        console.log(transaction);
        axios
          .put(`/auth/profile/${user?.id}`, { planTitle: plan })
          .then(({ data }) => {
            // console.log(data.subscription, user.subscription);

            setUserSubscription(data.subscription);
            // console.log(user, userSubscription);
          })
          .catch((err) => {
            console.log(err);
          });
      },
      onLoad: (response) => {
        console.log("onLoad: ", response);
      },
      onCancel: () => {
        console.log("onCancel");
      },
      onError: (error) => {
        console.log("Error: ", error.message);
      },
    });
  };

  useEffect(() => {
    axios
      .get(`/price`)
      .then(({ data }) => {
        if (data) {
          setPrice(data.price);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <article className="plan_card">
      <div>
        <h3 id="plan_title">Daily VIP Plan</h3>
        {/* <ul>{infoElements}</ul> */}
      </div>

      <div className="price">
        <img src="/images/daily.png" alt="" />
        <h1>GHS{price || 100}</h1>
      </div>

      <ul>
        <li style={{ fontWeight: "bold" }}>**Daily VIP Package</li>
        <li>**Premium Odds from the prediction Guru AsakaaPlay</li>
        <li>**Become a premium VIP member for: 1 day(s)</li>
        <li>**Recovery Tips Available</li>
        <li style={{ fontWeight: "bold" }}>
          **All VIP subscription are valid until slips are won**
        </li>
      </ul>

      <div>
        {!user ? (
          <Link to={"/login"}>
            <button className="btn pay">Pay now</button>
          </Link>
        ) : (user && isSubscribed) || user.email === "asakaagame@gmail.com" ? (
          <Link to={`/predictions/${plan.toLowerCase()}`}>
            <button className="btn pay">View Plan</button>
          </Link>
        ) : (
          <button className="btn pay" onClick={handlePayPlan}>
            Pay now
          </button>
        )}
      </div>
    </article>
  );
}

export default PlanCard;
